import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';

import { gqlRequest } from '../../../common/helpers/request';
import { getUserListAction, setUserListAction } from '../slices/comments';

const queryGQL = `
  query hostedWatchCommentsUsers(
    $page: Int,
    $pageSize: Int,
    $sortBy: String,
    $sortOrder: String,
    $searchText: String,
    $searchIn: [String],
    $videoId: String!,
  ) {
    hostedWatchCommentsUsers(
      page: $page,
      pageSize: $pageSize,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      searchText: $searchText,
      searchIn: $searchIn,
      videoId: $videoId,
    ) {
      id,
      email,
      firstName,
      lastName,
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(getUserListAction.type),
    mergeMap(({ payload }) => {
      const { searchText, searchIn, videoId } = payload;

      const queryParams = {
        page: 1,
        pageSize: 50,
        sortBy: 'firstName',
        sortOrder: 'asc',
        videoId,
      };

      if (searchText) {
        queryParams.searchText = searchText;
      }
      if (searchIn) {
        queryParams.searchIn = searchIn;
      }

      return gqlRequest({
        query: queryGQL,
        variables: queryParams,
      }).pipe(map(({ data, errors }) => setUserListAction(!errors.length ? data.hostedWatchCommentsUsers : [])));
    }),
  );
